if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      preFetch(opener) {
        const url = opener.getAttribute('data-product-url');
        if (!url) return;
        
        return fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            return responseHTML.querySelector('product-info');
          })
          .catch(err => {
            console.error('QuickAdd prefetch failed', err);
            return null;
          });
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const handleResponse = (productElement) => {
          if (!productElement) {
             // Fallback if prefetch failed or returned null
             fetch(opener.getAttribute('data-product-url'))
               .then(response => response.text())
               .then(text => {
                 const html = new DOMParser().parseFromString(text, 'text/html');
                 const el = html.querySelector('product-info');
                 this.finishShow(opener, el);
               });
             return;
          }
          this.finishShow(opener, productElement);
        };

        // Check if pre-fetch promise exists on the opener's parent (ModalOpener)
        const preFetchPromise = opener.parentElement.preFetchPromise;
        if (preFetchPromise) {
          preFetchPromise.then(handleResponse);
        } else {
          this.preFetch(opener).then(handleResponse);
        }
      }

      finishShow(opener, productElement) {
        if (!productElement) return;
        
        this.preprocessHTML(productElement);
        HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        super.show(opener);
        this.initGalleryDots(this.modalContent);
        
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        opener.querySelector('.loading__spinner').classList.add('hidden');
      }

      initGalleryDots(container) {
        const mediaContainer = container.querySelector('.cosmic-product-media');
        const dots = container.querySelectorAll('.cosmic-dot');
        if (!mediaContainer || !dots.length) return;

        mediaContainer.addEventListener('scroll', () => {
          const index = Math.round(mediaContainer.scrollLeft / mediaContainer.clientWidth);
          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
          });
        }, { passive: true });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
